import { useQuery } from 'react-query'
import { fetchManagerClasses } from '../services/managerClassesApi'
import type { UseLatestClassesResult } from '../interfaces'
import { LATEST_LIMIT, QUERY_RETRY, QUERY_STALE_TIME_MS } from '../constants'

export const useLatestClasses = (): UseLatestClassesResult => {
  const { data, isLoading, isError } = useQuery(
    ['manager-dashboard', 'latest-classes'],
    fetchManagerClasses,
    { staleTime: QUERY_STALE_TIME_MS, refetchOnWindowFocus: false, retry: QUERY_RETRY },
  )

  return {
    classes: (data ?? []).slice(0, LATEST_LIMIT),
    isLoading,
    isError,
  }
}
